import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useMutation } from 'react-query';
import { DirectoryCreateDoc } from 'types/directory';

export const useCreateDirectory = () => {
  const authState = useAuthSelector();
  return useMutation((directoryCreateDoc: DirectoryCreateDoc) =>
    sdk.directory.mutate.create(directoryCreateDoc, authState?.auth_token),
  );
};
